export const ORDER_PRINT_SETTINGS_KEY = "orderPagePrintSettings";

const normalizePrintSettings = (settings, defaults = { isPrintEnabled: false, isDisablePrintAPI: true }) => ({
  isPrintEnabled: typeof settings?.isPrintEnabled === "boolean"
    ? settings.isPrintEnabled
    : defaults.isPrintEnabled,
  isDisablePrintAPI: typeof settings?.isDisablePrintAPI === "boolean"
    ? settings.isDisablePrintAPI
    : defaults.isDisablePrintAPI,
});

export const getOrderPrintSettings = () => {
  let defaults = { isPrintEnabled: false, isDisablePrintAPI: true };
  try {
    defaults = {
      isPrintEnabled: Number(localStorage.getItem("LoaiCH")) === 3,
      isDisablePrintAPI: !["145", "1000", "78", "90"].includes(localStorage.getItem("IDCH")),
    };
    return normalizePrintSettings(JSON.parse(localStorage.getItem(ORDER_PRINT_SETTINGS_KEY)), defaults);
  } catch {
    return defaults;
  }
};

export const saveOrderPrintSettings = (settings) => {
  try {
    localStorage.setItem(ORDER_PRINT_SETTINGS_KEY, JSON.stringify(normalizePrintSettings(settings)));
    return true;
  } catch {
    return false;
  }
};

export const clearSessionPreservingPrintSettings = () => {
  const printSettings = localStorage.getItem(ORDER_PRINT_SETTINGS_KEY);
  localStorage.clear();
  if (printSettings !== null) {
    localStorage.setItem(ORDER_PRINT_SETTINGS_KEY, printSettings);
  }
};
